import {
    dateFilterKeys,
    fromUrlToFilters,
    getSearchFilters,
    getUrlFilters,
    objectToArray,
    TAGS_FILTER_PARAM,
} from 'shared/lib/filterHelper';

import IServerIncidentFilters from 'features/server/model/ServerIncident/IServerIncidentFilters';

export const SERVER_FILTER_KEYS = [
    'status',
    'os',
    'agent_version',
    ...dateFilterKeys('last_seen_at'),
    ...dateFilterKeys('created_at'),
];

export function getServerFilterArray(params: URLSearchParams): string[] {
    return [
        ...getSearchFilters(params),
        ...getUrlFilters(params, SERVER_FILTER_KEYS),
        ...objectToArray({tags: params.getAll(TAGS_FILTER_PARAM)}),
    ];
}

export const SERVER_INCIDENT_FILTER_KEYS: readonly (keyof IServerIncidentFilters)[] = [
    'server.uuid',
    'rule.uuid',
    'metric',
    'severity',
    'exists[closed_at]',
    'opened_at[after]',
    'opened_at[before]',
    'closed_at[after]',
    'closed_at[before]',
];

export function getServerIncidentFilters(params: URLSearchParams): IServerIncidentFilters {
    const filters: IServerIncidentFilters = {};
    SERVER_INCIDENT_FILTER_KEYS.forEach(key => fromUrlToFilters(params, filters, key));

    return filters;
}
